const commonFn = {};

// id
commonFn.ParkId = 50;
commonFn.parkName = '宁波熊出没欢乐港湾';

// 文字展示
commonFn.wordShow = function (doms, delay) {
  delay = delay || 0;
  var time = 0;
  for (var i = 0; i < doms.length; i++) {
    (function () {
      var j = i;
      setTimeout(function () {
        doms.eq(j).addClass('word_show');
      }, time);
      time = time + delay;
    }());
  }
}
// 打电话
commonFn.callTel = function (tel) {
  var a = document.createElement("a");
  a.href = "tel:" + tel;
  a.click()
}
// 路由跳转
commonFn.toPage = function (path, query = {}) {
  if (path == -1) {
    window.history.length == 1 ? this.$router.push('/') : this.$router.back();
    return;
  }
  if (!path) { return; }
  if (/^http/.test(path)) {
    window.open(path)
  } else {
    this.$router.push({
      path,
      query
    });
  }
}
// 时间格式
commonFn.time = function (val, format) {
  format = format || 'YYYY-MM-DD';
  if (/\/Date/.test(val)) {
    val = parseInt(val.replace("/Date(", "").replace(")/", ""))
  }
  let time = new Date(val);
  if (time == 'Invalid Date') {
    return val;
  }
  let obj = {
    'YYYY': time.getFullYear(),
    'MM': time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1,
    'M': time.getMonth() + 1,
    'DD': time.getDate() < 10 ? '0' + time.getDate() : time.getDate(),
    'D': time.getDate(),
    'hh': time.getHours() < 10 ? '0' + time.getHours() : time.getHours(),
    'h': time.getHours(),
    'mm': time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes(),
    'm': time.getMinutes(),
    'ss': time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds(),
    's': time.getSeconds()
  }
  for (let i in obj) {
    format = format.replace(i, obj[i]);
  }
  return format;
}

export default commonFn;